import { useConsentStore } from '../store';
import { ConsentStore } from '@/types';

export const useConsent = (): ConsentStore => {
  return useConsentStore();
};
